// TODO move the imports into the modules that require them

// jquery plugins just need to be imported since they add methods to jquery global
// some of the other ones put their API on the global scope
// rest use module loading and need to be imported and made global, see below
import * as jQuery from 'jquery';
import * as ColorThief from '@mariotacke/color-thief';
import 'cropper';
import 'intl-tel-input/build/js/utils';
import '@claviska/jquery-minicolors';
import * as moment from 'moment';
import 'moment-timezone';
import * as toastr from 'toastr';
import * as _ from 'underscore';
import * as WebFont from 'webfontloader';
import './tinymce';

// when all js code is turned into ts modules we can remove this, because this bundle is large now
window['_'] = _;
window['$'] = jQuery;
window['ColorThief'] = ColorThief;
window['jQuery'] = jQuery;
window['moment'] = moment;
window['toastr'] = toastr;
window['WebFont'] = WebFont;
